export default "__VITE_ASSET__BFk9sxsJ__"